/**
 * @generated SignedSource<<5ce5e1b177ef46ca7dda331905ab6c74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutShippingReducer_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly city: string | null;
      readonly company: string | null;
      readonly country: string | null;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly line1: string | null;
      readonly line2: string | null;
      readonly phoneNumber: string | null;
      readonly priceBookName: string | null;
      readonly serviceId: string | null;
      readonly state: string | null;
      readonly validation: {
        readonly buyerShipping: {
          readonly valid: boolean | null;
        } | null;
      } | null;
      readonly zipCode: string | null;
    } | null> | null;
    readonly personalAddress: {
      readonly priceBookName: string | null;
      readonly serviceId: string | null;
      readonly validation: {
        readonly buyerShipping: {
          readonly valid: boolean | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly firstValidShippingAddress: {
    readonly priceBookName: string | null;
    readonly serviceId: string | null;
  } | null;
  readonly profile: {
    readonly country: string | null;
  } | null;
  readonly " $fragmentType": "checkoutShippingReducer_buyer";
};
export type checkoutShippingReducer_buyer$key = {
  readonly " $data"?: checkoutShippingReducer_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutShippingReducer_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutShippingReducer_buyer"
};

(node as any).hash = "e992d233696e60d88e096ff53c38a019";

export default node;
